import { useMemo, useState } from "react";
import { Input } from "../ui/input";
import { personMatch } from "../../lib/searchText";

export const EmpSelect = ({ employees, value, onChange, testId = "legal-emp" }) => {
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim();
    return (employees || []).filter((e) => personMatch(e, s));
  }, [employees, q]);
  return (
    <div className="space-y-1.5">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث بالاسم أو رقم الإقامة…" className="h-9" data-testid={`${testId}-search`} />
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`${testId}-select`}
        className="h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-sm">
        <option value="">— بدون موظف —</option>
        {list.map((e) => <option key={e.id} value={e.id}>{e.name}{e.branch ? ` · ${e.branch}` : ""}</option>)}
      </select>
    </div>
  );
};

export const UserSelect = ({ users, value, onChange, exclude, testId }) => (
  <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className="h-10 w-full rounded-md border border-slate-200 bg-white px-2 text-sm">
    <option value="">— اختر الشخص —</option>
    {(users || []).filter((u) => u.id !== exclude).map((u) => <option key={u.id} value={u.id}>{u.name}{u.is_rep ? " ⚖️ (الممثل القانوني)" : ""}</option>)}
  </select>
);
